import { deleteSubscribe, subscribeList, addSubscribe } from '@/service'
const atten_common = {
  inject: ['haddleApplyTry', 'showAttenMessage'],
  computed: {
    _ids_entity() {
      return function (t) {
        if (this.$store.state.attention.subscribe) {
          return this.$store.state.attention.subscribe
            .filter((item) => {
              return item.sub_type == t
            })
            .map((item) => {
              return item.sub_type_id
            })
        } else {
          return []
        }
      }
    }
  },
  data() {
    return {
      change_loading: false
    }
  },
  methods: {
    // 获取关注信息
    async getSubscribeList(callBack) {
      let res = await subscribeList({
        user_key: this.$store.state.user_key
      },(error) => {
        this.$Message.error('请求错误！')
      })
      this.change_loading = false
      this.$Message.destroy()
      if(res.status == 'success') {
        this.$store.commit('updateFilter', {
          g_relation:res.g_relation,
          group:res.group,
          subscribe:res.subscribe
        })
        if(callBack) callBack()
      } else {
        this.$Message.error(res.msg)
      }
    },
    async deleteSubscribe(subscribe_id, cellback) {
      if(this.change_loading) {
        return false
      }
      this.change_loading = true
      this.$Message.loading({
        content: '操作中，请稍等',
        duration: 0
      })
      let res = await deleteSubscribe({
        user_key: this.$store.state.user_key,
        op_type: 'cancel',
        subscribe_id: subscribe_id
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.getSubscribeList(cellback)
      } else {
        this.change_loading = false
        this.$Message.destroy()
        this.$Message.error(res.message)
      }
    },
    async addSubscribe (sub_type, sub_type_id, cellback) {
      if(this.change_loading) {
        return false
      }
      this.change_loading = true
      this.$Message.loading({
        content: '添加关注中，请稍等',
        duration: 0
      })
      let res = await addSubscribe({
        sub_type: sub_type,
        sub_type_id: sub_type_id,
        user_key: this.$store.state.user_key
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        this.getSubscribeList(cellback)
      } else {
        this.change_loading = false
        this.$Message.destroy()
        if(res.code == 2000) {
          this.haddleApplyTry('温馨提示', '最多关注30家'+(this.entitytype == 0 ? '公司' : '机构')+'，动脉橙机构版无限制，欢迎试用动脉橙机构版。', 25)
        } else {
          this.$Message.error(res.message)
        }        
      }
    },
    subscribeSuccess() {
      if (this.$store.state.atten_message != 1) {
        this.showAttenMessage()
      } else {
        this.$Message.success('关注成功！')
      } 
    },
    cancelSuccess() {
      this.$Message.success('取消成功！')
    }
  }
}

export { atten_common }